import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TuiButton, TuiGroup, TuiScrollbar } from '@taiga-ui/core';
import { TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';

import { ContactsDirectoryComponent } from './contacts-directory.component';
import {
  DirectoryListComponent,
  FooterComponent,
  HeaderComponent,
  ListComponent,
  ListEditComponent,
  ListViewComponent,
  ValuesListComponent,
  ListItemViewComponent,
  ListItemEditComponent,
} from './components';

@NgModule({
  declarations: [
    ContactsDirectoryComponent,
    ListComponent,
    ListEditComponent,
    ListViewComponent,
    HeaderComponent,
    FooterComponent,
    ListItemViewComponent,
    ListItemEditComponent,
    ValuesListComponent,
    DirectoryListComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TuiButton,
    DragDropModule,
    TuiGroup,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiScrollbar,
  ],
  exports: [ContactsDirectoryComponent],
})
export class ContactsDirectoryModule {}
